namespace $ {
	export function $easyreels_gql_user_request(query: string, variables?: object, opts?: $easyreels_gql_opts): unknown {
		return $easyreels_gql_post('/graphql', query, variables, opts)
	}

	export type $easyreels_gql_user_ref<Frag> = $easyreels_gql_ref<Frag>
}
